export class VariantEvaluationViewParameters {
    id: number;
    name: string;
    doors: Array<any>;
    separatDeckAreaSelection: string[];
    acrossDeckAreaSelection: string[];
    hasCollissions: boolean;
}